module.exports = __webpack_public_path__ + "static/08-71a5ea4dca97d55c1a62f06c19beccee.png";